import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { AppStore } from '../../../app/app.store';
import { AvatarComponent } from '../avatar/avatar.component';
import { UserProfileComponent } from '../../../app/features/edit-profile/components/user-profile.component';
import { AuthStore } from '../../../app/features/login/store/auth.store';
import { UsersManagementStore } from '../../../app/features/users-management/store/users-management.store';
import { Overlay, OverlayModule } from '@angular/cdk/overlay';

@Component({
  selector: 'app-toolbar',
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    AvatarComponent,
    UserProfileComponent,
    OverlayModule,
  ],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarComponent implements OnInit {
  readonly store = inject(AppStore);
  readonly authStore = inject(AuthStore);
  readonly usersStore = inject(UsersManagementStore);
  readonly overlay = inject(Overlay);

  ngOnInit() {
    setInterval(() => this.store.startClock(), 1000);
  }

  toggleUserProfile() {
    this.store.toggleUserProfile();
    this.store.showUserProfile()
      ? this.usersStore.setTempUser(this.authStore.currentUser()!)
      : this.usersStore.setTempUser(null);
  }
}
